import { useHospitalDetailContext } from '../hospital-detail-context'

import PhotoSlide from '@/features/hospital/components/photo-slide'

export const HospitalDetailPhotoSlider = () => {
  const { hospital } = useHospitalDetailContext()

  return (
    <PhotoSlide
      country={hospital.country}
      photos={hospital.images.otherImages.map((img) => img.imageUrl)}
      name={hospital.name}
    />
  )
}
